export default "__VITE_ASSET__nr5GTZex__"